import moment from 'moment';

/**
 * Formats a date like the `moment` filter of vue-moment did. Filters are not type checked by vue-tsc
 * (and were removed in Vue 3), so templates use `$formatDate(value, 'DD.MM.YYYY')` instead.
 * `format` is a moment format string, or 'from' for the time relative to now ("vor 2 Tagen").
 */
export function formatDate(value: moment.MomentInput, format: string): string {
	let date: moment.Moment;
	if (typeof value === 'number') {
		// numbers with fewer than 12 digits are unix seconds, others milliseconds
		date = value.toString().length < 12 ? moment.unix(value) : moment(value);
	} else {
		date = moment(value);
	}
	if (!value || !date.isValid()) {
		return value == null ? '' : String(value);
	}
	return format === 'from' ? date.fromNow() : date.format(format);
}

declare module 'vue/types/vue' {
	interface Vue {
		$formatDate: typeof formatDate;
	}
}
